import React from "react";

const SendFeedbackModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal fade show d-block" role="dialog" aria-labelledby="facility_form_submission_send_feedback">
      <div className="modal-dialog" role="document">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title">Send Feedback Message</h5>
            <button className="close" aria-label="Close" type="button" onClick={onClose}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body">
            {children}
          </div>

        </div>
      </div>
      <div className="modal-backdrop fade show" style={{ zIndex: 1}} onClick={onClose}></div>
    </div>
  );
};

export default SendFeedbackModal;
